import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import "tailwindcss/tailwind.css";

import "./App.css";
import "./assets/style/index.scss";
import AppContainer from "./AppContainer";
import store from "./store";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContainer />
      </Router>
    </Provider>
  );
}

export default App;
